<template>
  <transition name="slide-fade">
    <div class="overlay w-100 absolute">
      <div @click="close" class="w-60-l w-50-m db-ns dn absolute z-2 bottom-0 top-0 overlay-width"/>
      <div class="profile z-3 fixed flex flex-column w-40-l w-50-m w-100 profile-width bg-tertiary">
        <div class="image-container relative db w-100 cover center"
             :style=" { 'background-image': 'url(' + picture + ')' }">
          <a @click="close" class="ma2 pointer z-4 fixed right-0 textColor">
            <font-awesome-icon icon="times" size="2x"/>
          </a>
          <div v-show="!loadingArtist"
               class="playlist-picture-container absolute flex justify-start items-center bg-primary">
            <img :src="playlistPicture" :alt="`${playlist.title} Picture`" />
          </div>
          <div v-show="!loadingArtist"
               class="playlist-name-container absolute flex justify-start items-center bg-primary mw-50">
            <span class="playlit-name z-4 f3-ns f4 white pa2 textColor">{{ playlist.title }}</span>
          </div>
          <div class="follow-container absolute flex">
            <button @click="setPlayer(playlist.tracks[0], playlist.tracks)" class="like-button pa2 pointer pv1 flex justify-start items-center" title="Play">
              <font-awesome-icon class="iconColor playlistOptions" icon="play"/>
            </button>
            <button v-show="$router.history.current.name === 'my-playlists'" @click="deletePlaylist()" class="like-button pa2 pointer pv1 flex justify-start items-center" :title="$t('playlists.delete.title')">
              <font-awesome-icon class="iconColor playlistOptions" icon="trash"/>
            </button>
            <button v-show="$router.history.current.name === 'my-playlists'" @click="editPlaylist()" class="like-button pa2 pointer pv1 flex justify-start items-center" :title="$t('playlists.edit.button')">
              <font-awesome-icon class="iconColor playlistOptions" icon="edit"/>
            </button>
            <button v-show="!playlist.private" @click="sharePlaylist()" class="like-button pa2 pointer pv1 flex justify-start items-center" :title="$t('playlists.share.button')">
              <font-awesome-icon class="iconColor playlistOptions" icon="share-alt"/>
            </button>
            <button v-if="$router.history.current.name !== 'my-playlists'" @click="likePlaylist()" class="like-button pa2 pointer pv1 flex justify-start items-center" :title="$t('playlists.like.button')">
              <font-awesome-icon class="playlistOptions" :class="liking ? 'liked' : 'iconColor'" icon="heart"/>
            </button>
          </div>
        </div>
        <div class="data-container">
          <div class="profile-tabs bg-tertiary h-6">
            <div class="h-100 bg-tertiary flex justify-center pl1 pr1">
              <p class="ttu tracked dib pa2 textColor pointer tab flex justify-center items-center">{{ $tc('tracks.track', 2)}}</p>
             </div>
          </div>
          <div>
            <PlayliststTracks/>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import {mixin as onClickOutside} from 'vue-on-click-outside'
  import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
  import consts from '@/consts'
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

  import PlayliststTracks from '@/components/PlaylistProfile/PlaylistTracks.vue'

  export default {
    name: 'playlist-profile',
    components: {
      FontAwesomeIcon,
      ClipLoader,
      PlayliststTracks
    },
    data () {
      return {
        color: '#808080',
        size: '20px',
        aId: null,
        followedArtistsArray: null,
        isFollowed: false,
        liking: false
      }
    },
    mixins: [onClickOutside],
    computed: {
      picture () {
        return '/static/assets/Img_generico_principal3.jpg'
      },
      playlistPicture () {
        if (this.playlist.picture) {
          return consts.MEDIA_BASE_URL + this.playlist.picture
        } else {
          return consts.BASE_HOST + '/static/assets/Img_comodines_Beathey_Playlist.jpg'
        }
      },
      ...mapGetters('player', ['currentTrack']),
      ...mapGetters('playlist', [
        'playlist',
        'playlistLiked'
      ]),
      ...mapGetters('user', [
        'isLoggedIn',
        'isSubscribed'
      ]),
      loadingArtist () {
        return this.$loading.isLoading('artist getArtist')
      },
      loadingVote () {
        return this.$loading.isLoading('artist setVote')
      },
      hasTracks () {
        return this.artistTracks.length > 0
      },
      voteDisabled () {
        return this.isSubscribed && this.myVotes === null
      }
    },
    methods: {
      ...mapActions('user', [
        'setFollowArtist',
        'getMyFollowedArtists'
      ]),
      ...mapActions('playlist', [
        'closePlaylist',
        'delete',
        'togglePlaylistLike'
      ]),
      ...mapMutations('user', [
        'setFollowing'
      ]),
      ...mapActions('player', [
        'setPlaylist',
        'setPlaying',
        'changeTrack'
      ]),
      playTrack (track) {
        if (this.currentTrack !== track) {
          this.$emit('play')
          this.changeTrack(track)
        } else {
          this.setPlaying(true)
        }
      },
      setPlayer (track, playlist) {
        this.setPlaylist(playlist)
        this.playTrack(track)
      },
      close () {
        this.closePlaylist()
        history.back()
        this.tab = 'artist-tracks'
      },
      deletePlaylist () {
        this.$modal.show('dialog', {
          title: this.$t('playlists.delete.title'),
          text: this.$t('playlists.delete.confirm'),
          buttons: [
            {
              title: this.$t('app.yes'),
              handler: () => {
                this.delete(this.playlist.id).then(() => {
                  this.$toasted.show(this.$t('playlists.delete.success'), {type: 'success'})
                  this.close()
                }).catch((e) => {
                  this.$toasted.show(this.error.message, {type: 'error'})
                })
                this.$modal.hide('dialog')
              }
            },
            {
              title: this.$t('app.no'),
              default: true,
              handler: () => {
                this.$modal.hide('dialog')
              }
            }
          ]
        })
      },
      editPlaylist () {
        this.playlist.picture = this.playlist.picture ? this.playlist.picture : '/static/assets/Img_comodines_Beathey_Playlist.jpg'
        this.$modal.show('new-playlist-modal', {playlist: this.playlist})
      },
      sharePlaylist () {
        this.$modal.show('share-modal', {
          link: consts.BASE_HOST + '/services/share/playlist/' + this.playlist.id,
          title: this.playlist.title,
          // playlist de artistname
          description: '',
          playlist: this.playlist
        })
      },
      likePlaylist () {
        this.togglePlaylistLike(this.playlist.id).then(() => {
          this.$root.$emit('togglePlaylistLike', this.playlist.id)
          this.liking = this.playlistLiked
        }).catch((e) => {
          this.$toasted.show(this.error.message, {type: 'error'})
        })
      }
    },
    beforeUpdate () {
      this.liking = this.playlist.liked
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  .followButton {
    background: #E6007E;
    padding: 0px 0px;
    border-radius: 100px;
  }
  .followinButton {
    background: #E6007E;
    padding: 0px 0px;
    border-radius: 100px;
  }

  .overlay {
    top: 3em;
    bottom: 50px;
    left: 0;
    height: $main-height;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .profile {
    right: 0;
    height: $main-height
  }

  .image-container {
    height: 35%;
    min-height: 35%;
    background-position: center center;
  }

  .image-container::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: linear-gradient(to top right, transparent 65%, rgba(255, 255, 255, 0.8));
  }

  .data-container {
    height: 65%;
  }

  .playlist-name-container {
    max-width: 50%;
    bottom: 5%;
    left: 5%;
  }

  .playlist-picture-container {
    width: 124px;
    height: 124px;
    bottom: 30%;
    left: 5%;
  }

  .vote-container {
    bottom: 5%;
    right: 5%;
    border: none;
    padding: 0px 0px;
    border-radius: 100px;
  }

  .follow-container {
    bottom: 5%;
    right: 25%;
    border: none;
  }

  .playlit-name {
    white-space: nowrap;
    max-width: 100%;
    min-width: 108px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .profile-tabs {
    height: 8%;
  }

  .tab {
    flex-grow: 1;
    text-align: center;
    font-size: 0.6rem;
  }

  .disabled-tab {
    pointer-events: none;
    cursor: default;
  }

  .disabled {
    opacity: 0.5 !important;
    cursor: default;
  }

  .profile-tab-content {
    height: 92%;
  }

  .router-link-active, .link:hover {
    background-color: #f4f3f4;
    transition: .3s;
  }

  .slide-fade-enter-active {
    transition: all .3s ease;
  }

  .slide-fade-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }

  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }

  .votes {
    height: 16px;
    width: 16px;
  }

  .bg-tertiary{
    background-color: $background-color;
  }

  .minH-316 {
    min-height: 316px;
  }
  .minH-280 {
    min-height: 280px;
  }
  .minH-220 {
    min-height: 220px;
  }
  .like-button{
    background-color: rgb(39, 39, 39);
    border: none;
    text-align: right;
    cursor: pointer;
  }
  .liked {
    color: red;
  }

  .playlistOptions {
    height: 25px;
    width: 25px;
  }

  @media screen and (max-width: 780px) and (min-width: 300px) {
    .profile-width {
      width: 75%;
    }
    .overlay-width {
      width: 25%
    }
    .follow-container {
      right: 5%;
      bottom: 17%;
    }
    .followButton {
      padding: 0px 17px;
    }
    .followinButton {
      padding: 0px 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PlaylistProfile/PlaylistProfile.vue